import { render } from "./HelperButtons.vue?vue&type=template&id=0ef84152&scoped=true"
import script from "./HelperButtons.vue?vue&type=script&lang=ts"
export * from "./HelperButtons.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-0ef84152"

export default script
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QSpace from 'quasar/src/components/space/QSpace.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QMenu,QList,QItem,QItemSection,QBtnGroup,QSpace});qInstall(script, 'directives', {ClosePopup});
